module.exports = "/assets/a9591781f7a353e836d71705348de46d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KL.png
// module id = 1549
// module chunks = 0